import type { Load } from 'api';
import { formatDateTime } from 'date';
import { translate } from 'i18n';
import { Link } from 'react-router-dom';
import { Button, DetailsList, Stack } from 'ui';

import { formatLoadStatus } from '../../utils/formatLoadStatus';
import { LoadStatusChip } from '../LoadStatusChip/LoadStatusChip';

export const LoadDetails = ({
  load,
  onNotNeededClick,
}: {
  load: Load | null;
  onNotNeededClick: (id: number) => void;
}) => {
  const handleInspectionIsNotNeeded = async () => {
    if (load?.id) {
      onNotNeededClick(load.id);
    }
  };

  return (
    <DetailsList
      details={[
        {
          title: translate('backlog.loadDetails.fields.status', { namespace: 'features' }),
          value: (
            <Stack
              direction="row"
              sx={{
                justifyContent: 'space-between',
              }}
            >
              <LoadStatusChip status={formatLoadStatus(load?.status)} />
              {load?.status !== 'Not needed' && (
                <Button onClick={handleInspectionIsNotNeeded} variant="secondary" size="small">
                  {translate('backlog.loadDetails.actions.notNeeded', { namespace: 'features' })}
                </Button>
              )}
            </Stack>
          ),
        },
        {
          title: translate('backlog.loadDetails.fields.collectionTime', { namespace: 'features' }),
          value: formatDateTime(load?.estimated_collection_time),
        },
        {
          title: translate('backlog.loadDetails.fields.inspection', { namespace: 'features' }),
          value: load?.inspection_id ? (
            <Link to={`/ground-control/inspections/${load.inspection_id}/`}>
              {translate('backlog.loadDetails.values.hasInspection', { namespace: 'features' })}
            </Link>
          ) : (
            translate('backlog.loadDetails.values.noInspection', { namespace: 'features' })
          ),
        },
      ]}
    />
  );
};
